module.exports = __webpack_public_path__ + "media/images/icon/phone-12af1909fab33b698303c2ad5ab0c0e4.svg";